import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center py-3 cursor-pointer justify-space-between" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "text-blue ms-2 font-bold" }
const _hoisted_4 = { class: "text-small text-gray" }
const _hoisted_5 = { class: "ms-1" }

import { format } from 'date-fns'
import Inquiry from '../../../api/v2/models/inquiry'


export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryView',
  props: {
    inquiry: {}
  },
  setup(__props: any) {



const dateFormat = (date: Date | string) => {
  return format(new Date(date), 'YYYY/MM/DD HH:mm')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(__props.inquiry.updatedAt ? dateFormat(__props.inquiry.updatedAt) : ''), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.inquiry.title), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.inquiry.commentCount)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-comment", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.inquiry.commentCount) + " コメント", 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "action")
    ])
  ]))
}
}

})